import React, { useState, useEffect } from 'react';
import { AlertCircle, TrendingDown, TrendingUp } from 'lucide-react';
import { api } from '../services/apiClient';

const InventoryManager = () => {
  const [illustrations, setIllustrations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchInventory();
  }, []);

  async function fetchInventory() {
    setLoading(true);
    try {
      const data = await api.illustrations.list();
      setIllustrations(data);
    } catch (err) {
      console.error('Errore caricamento inventario:', err);
    }
    setLoading(false);
  }

  const lowStockItems = illustrations.filter(i => i.total_stock < i.min_stock_threshold);
  const outOfStockItems = illustrations.filter(i => i.total_stock === 0);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white p-6 rounded-xl border border-brand-main shadow-sm flex items-center gap-4">
          <div className="p-3 bg-orange-100 text-orange-600 rounded-full"><AlertCircle size={24} /></div>
          <div>
            <p className="text-sm text-gray-500">Rifornimenti Necessari</p>
            <p className="text-2xl font-bold">{lowStockItems.length}</p>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl border border-brand-main shadow-sm flex items-center gap-4">
          <div className="p-3 bg-red-100 text-red-600 rounded-full"><TrendingDown size={24} /></div>
          <div>
            <p className="text-sm text-gray-500">Esaurite</p>
            <p className="text-2xl font-bold">{outOfStockItems.length}</p>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl border border-brand-main shadow-sm flex items-center gap-4">
          <div className="p-3 bg-green-100 text-green-600 rounded-full"><TrendingUp size={24} /></div>
          <div>
            <p className="text-sm text-gray-500">Stato Magazzino</p>
            <p className="text-2xl font-bold">{illustrations.length > 0 ? 'Ottimale' : 'Vuoto'}</p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-brand-main overflow-hidden shadow-sm">
        <div className="p-4 bg-gray-50 border-b border-brand-main font-semibold">Rapporto Dettagliato Scorte</div>
        <div className="overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead className="bg-gray-50 text-gray-500 uppercase text-xs">
            <tr>
              <th className="px-6 py-3">Opera</th>
              <th className="px-6 py-3">Categoria</th>
              <th className="px-6 py-3 text-center">Disponibile</th>
              <th className="px-6 py-3 text-center">Soglia Min.</th>
              <th className="px-6 py-3 text-right">Stato</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {loading ? (
              <tr><td colSpan="5" className="p-8 text-center text-gray-400">Caricamento...</td></tr>
            ) : illustrations.map(item => (
              <tr key={item.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 font-medium">{item.name}</td>
                <td className="px-6 py-4 text-gray-500">{item.categories?.name || 'N/D'}</td>
                <td className="px-6 py-4 text-center font-bold">{item.total_stock}</td>
                <td className="px-6 py-4 text-center text-gray-400">{item.min_stock_threshold}</td>
                <td className="px-6 py-4 text-right">
                  {item.total_stock === 0 ? (
                    <span className="bg-red-100 text-red-600 px-2 py-1 rounded-full text-xs font-bold">ESAURITA</span>
                  ) : item.total_stock < item.min_stock_threshold ? (
                    <span className="bg-orange-100 text-orange-600 px-2 py-1 rounded-full text-xs font-bold">RICARICARE</span>
                  ) : (
                    <span className="bg-green-100 text-green-600 px-2 py-1 rounded-full text-xs font-bold">OK</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
};

export default InventoryManager;
